<template>
  <img class="cdn-image" :src="cdnImagePath" />
</template>

<script>
export default {
  name: 'CdnImage',
  props: {
    imagePath: String,
  },
  computed: {
    cdnImagePath() {
      return this.$config.cdnImgUrl + this.imagePath
    },
  },
}
</script>
